import { ALGOLIA_INDEX } from '@/config/algolia.config'

const SET_FEEDBACKS = 'SET_FEEDBACKS'

const state = () => {
  return {
    feedbacks: null,
  }
}

const mutations = {
  [SET_FEEDBACKS]: (state, feedbacks) => {
    state.feedbacks = feedbacks
  },
}

const actions = {
  async getFeedback({ commit }) {
    const { feedback } = await ALGOLIA_INDEX.getObject('savoiexpo')
    commit(SET_FEEDBACKS, feedback)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
